import { chakra, Flex, FlexProps, Icon, Text } from '@chakra-ui/react';
import { ProfileCard } from 'types/profile';
import { ReactComponent as MessageIcon } from 'resources/images/message.svg';
import { ChakraAvatarGroup } from 'app/components/ChakraAvatarGroup';

export interface ChatMembersProps extends FlexProps {
  users: ProfileCard[];
  unreadMessageCount: number;
  maxGroupSize: number;
  showUnreadIndicator?: boolean;
}

export const ChatMembers = ({
  users,
  maxGroupSize,
  unreadMessageCount,
  showUnreadIndicator,
  ...rest
}: ChatMembersProps) => {
  const isEmpty = users.length === 0;
  const showNewMessageCount = unreadMessageCount > 0;

  return (
    <Flex alignItems="center" {...rest}>
      <ChakraAvatarGroup maxGroupSize={maxGroupSize} users={users} />
      {isEmpty && <Icon as={MessageIcon} color="textBase" />}
      <Flex pl={isEmpty ? 1 : 2} alignItems="center">
        <Text fontSize="sm">Messages</Text>
        {showNewMessageCount && (
          <Text color="iconAccent" fontWeight={500} fontSize="xs" pl={1}>
            ({unreadMessageCount})
          </Text>
        )}
        {showUnreadIndicator && (
          <chakra.span
            ml={1}
            height={2}
            width={2}
            bg="iconAccent"
            borderRadius="full"
          />
        )}
      </Flex>
    </Flex>
  );
};
